import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import Logo from './Logo';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-16 bg-zinc-950 border-t border-zinc-900">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
          {/* Logo */}
          <div className="text-white">
            <Logo size="default" variant="simple" />
          </div>

          {/* Right - Copyright */}
          <div className="text-center lg:text-right">
            <p className="text-sm text-zinc-600">
              © {currentYear} Interware SAS
            </p>
            <a 
              href="https://interware.dev" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-xs text-zinc-700 hover:text-cyan-400 transition-colors"
            >
              {t.footer.domain}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
